const mutations = {
  mutationPaymentToInsurerRequest(state, payload) {
    state.paymentToInsurerRequest = payload;
  },

  mutationPaymentToInsurerRequestList(state, payload) {
    if (payload && (payload.tab || payload.tab === 0)) {
      state.paymentToInsurerRequestList[payload.tab] = payload.responseData;
    } else {
      state.paymentToInsurerRequestList = payload;
    }
  },

  mutationPaymentToInsurerRequestMeta(state, payload) {
    state.paymentToInsurerRequestMeta = payload;
  },

  mutationInsurerBranchList(state, payload) {
    state.insurerBranchList = payload;
  },

  resetInsurerBranchList(state) {
    state.insurerBranchList = [];
  },

  mutationSelectedInsurer(state, payload) {
    state.selectedInsurer = payload;
  },

  mutationFetchParameter(state, payload) {
    state.fetchParameter = payload;
  },
};

export default mutations;
